// extracted by mini-css-extract-plugin
module.exports = {"box":"box-2iZ7-ou_ clearfix"};